var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GuideSteps',{attrs:{"steps":_vm.steps}},[_c('template',{slot:"header"},[_vm._v("\n        "+_vm._s(_vm.$t('MultivoucherSteps.header', { platformName: _vm.platformName }))+"\n    ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }